import { Link } from "react-router-dom"
import "./AboutContent.css"
import React from 'react'
import Mern1 from "../resources/Mern1.jpg"
import Mern2 from "../resources/Mern2.jpg"
import Photo from "../resources/pic.png"


const AboutContent = () => {
  return (
<div className="about" id="about">
 <div className="left">
    <h1>Who Am I ?</h1>
    <p>Proficient MERN developer with expertise in full stack web
development. Demonstrated skills in solo and
collaborative projects, showcasing adaptability to new
technologies. Adept at leveraging Generative AI, with a
keen aptitude for rapid acquisition of diverse tech stacks.
Strong problem-solving abilities and a collaborative
mindset drive project success.</p>

   
    <Link to="https://drive.google.com/file/d/1IK_RuO422W3LBKClLBlmaQZ68OWD7Ooo/view" target="_blank"><button className="btn">Resume</button></Link>
    
 </div>
 <div className="right">
 <img src={Photo} className="img" alt="Mern1" />
 </div>
 {/* <div className="right">
    <div className="img-container">
        <div className="img-stack-top">
<img src={Mern1} className="img" alt="Mern1" />
        </div>
        <div className="img-stack-bottom">
<img src={Mern2} className="img" alt="Mern2" />
        </div>
    </div>
 </div> */}
 {/* <div className="photo">
 <img src={Photo} className="img" alt="Mern1" />
 </div> */}
</div>
  )
}

export default AboutContent